import React from 'react';
import PropTypes from 'prop-types';
import ImageCard from './ImageCard';
import ImageDropzoneField from 'components/input/Dropzone/ImageDropzoneField';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const Container = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
`;

const PhotoWrapper = styled.div`
    display: block;
    box-sizing: border-box;
    margin: 0 10px 10px 0;
    position: relative;
    width: 320px;

    img {
        width: 320px;
        height: 200px;
    }
`;

const ImageGrid = (props) => {
    const {
        createAction,
        data,
        id,
        onDelete,
        onHighlightImage,
        showHighlightOption,
        translate,
    } = props;

    return (
        <Container>
            {
                !!data && utils.map(data, (image) => {
                    if (image.relationships.images.data.type !== 'logo') {
                        return (
                            <PhotoWrapper key={ image.relationships.images.data.url }>
                                <ImageCard
                                    id={ id }
                                    image={ image }
                                    onDelete={ onDelete }
                                    onHighlightImage={ onHighlightImage }
                                    showHighlightOption={ showHighlightOption }
                                />

                            </PhotoWrapper>
                        );
                    }
                })
            }
            <PhotoWrapper>
                <ImageDropzoneField
                    acceptedFormat='image/jpg, image/jpeg'
                    buttonText={ translate('dropzone.label.button_image') }
                    createAction={ createAction }
                    id={ id }
                    minHeight={ 1440 }
                    minWidth={ 2560 }
                    multiple={ true }
                    formDataKey='image'
                    dropZoneId='product-images-drop-zone'
                />
            </PhotoWrapper>
        </Container>
    );
};

ImageGrid.propTypes = {
    createAction: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
    onHighlightImage: PropTypes.func,
    showHighlightOption: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default translate(ImageGrid);


// WEBPACK FOOTER //
// ./src/pages/products/images/ImageGrid.js